import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {
      id: "",
      quantity: 0,
      groupId: 0,
      organizationId: 0,
      tablets: []
  },
  registryData: {
    groupName: "",
    totalTablets: 0,
    groupId: 0,
    tablets: []
  },
  updating: false,
};

const tabletManagementSlice = createSlice({
  name: 'tabletManagement',
  initialState,
  reducers: {
    resetTabletState: (state) => {
      Object.assign(state, initialState);
    },
    setUpdatingTablet(state, action) {
      state.data = action.payload;
      state.updating = true;
    },
    setRegistryData(state, action) {
      state.registryData = action.payload;
    }
  },
});

export const {
    resetTabletState,
    setUpdatingTablet,
    setRegistryData
} = tabletManagementSlice.actions;

export default tabletManagementSlice.reducer;
